<template>
    <va-create-layout>
        <FbaInboundShipment-form
            :title="title"
            :item="item"
        ></FbaInboundShipment-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
